import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface IAutoAddToVisitTypeModel extends IModel {
  autoAddToVisitTypeId: number;
  name: string;
}

export class AutoAddToVisitTypeModel
  extends Model
  implements ModelRecord<IAutoAddToVisitTypeModel>
{
  autoAddToVisitTypeId: number;
  name: string;
  constructor(params?: Partial<IAutoAddToVisitTypeModel>) {
    super(params);
    this.autoAddToVisitTypeId = defaultTo(params?.autoAddToVisitTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
